import { render, staticRenderFns } from "./SingleOrderCreate.vue?vue&type=template&id=384358d8&scoped=true&"
import script from "./SingleOrderCreate.vue?vue&type=script&lang=js&"
export * from "./SingleOrderCreate.vue?vue&type=script&lang=js&"
import style0 from "./SingleOrderCreate.vue?vue&type=style&index=0&id=384358d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384358d8",
  null
  
)

export default component.exports